"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameServiceTransactionVersion = exports.NameServiceStaticFees = exports.NameServiceTransactionGroup = exports.NameServiceTransactionTypes = void 0;
const defaults_1 = require("./defaults");
var NameServiceTransactionTypes;
(function (NameServiceTransactionTypes) {
    NameServiceTransactionTypes[NameServiceTransactionTypes["Nameservice"] = 0] = "Nameservice";
})(NameServiceTransactionTypes = exports.NameServiceTransactionTypes || (exports.NameServiceTransactionTypes = {}));
exports.NameServiceTransactionGroup = defaults_1.defaults.nameserviceTypeGroup;
// parse to string
const nameserviceStaticFee = defaults_1.defaults.nameserviceStaticFee.toString();
var NameServiceStaticFees;
(function (NameServiceStaticFees) {
    NameServiceStaticFees[NameServiceStaticFees["Nameservice"] = nameserviceStaticFee] = "Nameservice";
})(NameServiceStaticFees = exports.NameServiceStaticFees || (exports.NameServiceStaticFees = {}));
exports.NameServiceTransactionVersion = defaults_1.defaults.version;
//# sourceMappingURL=enums.js.map